import { render, staticRenderFns } from "./ActivityUser.vue?vue&type=template&id=4dbe64ef&scoped=true&"
import script from "./ActivityUser.vue?vue&type=script&lang=js&"
export * from "./ActivityUser.vue?vue&type=script&lang=js&"
import style0 from "./ActivityUser.vue?vue&type=style&index=0&id=4dbe64ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbe64ef",
  null
  
)

export default component.exports